import React from 'react'
import { connect } from 'react-redux'

import DIALOGS_LIST from './dialogs'
import { getDialog } from '~/selectors/ui'

const DialogsRenderer = ({ dialog }) => (
  <>
    {DIALOGS_LIST[dialog]}
  </>
)

const mapStateToProps = state => ({
  dialog: getDialog(state)
})

export default connect(mapStateToProps)(DialogsRenderer)
